import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class PrintSections extends BaseClass {
  Category: BaseClass;
  Recipe: BaseClass;
  Products: BaseClass;
  constructor(obj: any = PERMISSIONS.BrandSections) {
    super(obj);
    this.Category = new BaseClass(obj.Category);
    this.Recipe = new BaseClass(obj.Recipe);
    this.Products = new BaseClass(obj.Products);
  }
}
